// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  width?: number;
  fill?: string;
};
export const Checkout = ({ fill = 'none', width = 14 }: Props) => (
  <chakra.svg
    height={`${width}px`}
    width={`${width}px`}
    fill={fill}
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99935 12.8341C3.77769 12.8341 1.16602 10.2224 1.16602 7.00081C1.16602 3.77915 3.77769 1.16748 6.99935 1.16748C10.221 1.16748 12.8327 3.77915 12.8327 7.00081C12.8327 10.2224 10.221 12.8341 6.99935 12.8341ZM6.99935 11.6675C9.57669 11.6675 11.666 9.57816 11.666 7.00081C11.666 4.42348 9.57669 2.33415 6.99935 2.33415C4.42202 2.33415 2.33268 4.42348 2.33268 7.00081C2.33268 9.57816 4.42202 11.6675 6.99935 11.6675ZM6.41753 9.33415L3.94268 6.8593L4.76764 6.03429L6.41753 7.68425L9.71739 4.3844L10.5423 5.20936L6.41753 9.33415Z"
      fill="#12D0A2"
    />
  </chakra.svg>
);
